import React, { Fragment, useEffect, useState } from 'react';
import { Dialog } from '@tencent/spaui';

import { RPCFactory } from '../../../../utils/RequestUtil';

import copy from 'copy-to-clipboard';
import useFeedback from '../../../hooks/useFeedback';

import FeedBackDialog from '../../../common/feedback';

const MyDialog = (props) => {
  const [leadsId, setLeadsId] = useState(props.value);
  const [leads, setLeads] = useState(props.value);
  const [pushExample, setPushExample] = useState(props.value);

  // const [showTip, setShowTip] = useState(false);
  // const [message, setMessage] = useState('');

  const testFeedbackHooks = useFeedback({ timeout: 0, type: 'confirm' });
  const copyFeedbackHooks = useFeedback();

  useEffect(() => {
    RPCFactory.leadsPushRule
      .example({
        ruleId: props.data.ruleId,
      })
      .done((data) => {
        setLeadsId(data.leadsId);
        setLeads(data.leads);
        setPushExample(data.pushExample);
      })
      .fail((code, msg) => {
        alert(msg);
      });
  }, []);

  const doTest = () => {
    RPCFactory.leadsPushRule
      .test({
        ruleId: props.data.ruleId,
        pushData: pushExample,
      })
      .done((data) => {
        testFeedbackHooks.showSuccessTipAndDetails('验证结果', data);
      })
      .fail((code, msg) => {
        testFeedbackHooks.showErrorTipAndDetails(msg);
      });
  };

  const copyData = (data) => {
    if (copy(data)) {
      copyFeedbackHooks.showSuccessTip('复制成功');
    } else {
      copyFeedbackHooks.showErrorTip('您的浏览器不支持复制，请手动复制');
    }
  };

  const HeaderComponentAccount = (props) => {
    const { onClose, title } = props;

    return (
      <div>
        <button type="button" className="close" onClick={onClose}>
          <span aria-hidden="true">×</span>
        </button>
        <h4 className="modal-title">
          推送测试
          <span className="modal-toptip">
            {leadsId == undefined ? '' : leadsId == 0 ? '系统构造' : `线索ID：${leadsId}`}
          </span>
        </h4>
      </div>
    );
  };

  return (
    <Fragment>
      <Dialog
        type="normal"
        hideFooter
        className="modal-pushtest"
        backdrop
        enabledBackdropClose
        title=""
        show={props.show}
        onClose={props.onClose}
        onSubmit={props.onClose}
        onCancel={props.onClose}
        style={{ width: '800px' }}
        cancelButton={false}
        HeaderComponent={HeaderComponentAccount}
      >
        <div className="codepush">
          <div className="field-push">
            <div className="topbar">
              <span>原始线索</span>
              <div className="action">
                <a
                  href="javascript:void(0)"
                  onClick={() => {
                    copyData(leads);
                  }}
                >
                  复制
                </a>
              </div>
            </div>
            <code>{leads}</code>
          </div>
          <div className="field-push">
            <div className="topbar">
              <span>推送示例</span>
              <div className="action">
                <a
                  href="javascript:void(0)"
                  onClick={() => {
                    copyData(pushExample);
                  }}
                >
                  复制
                </a>
                <a
                  href="javascript:void(0)"
                  onClick={() => {
                    doTest();
                  }}
                >
                  推送测试
                </a>
              </div>
            </div>
            <code className="after">
              <textarea
                onChange={(e) => {
                  setPushExample(e.target.value);
                }}
                value={pushExample}
              />
            </code>
          </div>
        </div>
      </Dialog>
      <FeedBackDialog {...testFeedbackHooks} modalStyle={{ zIndex: 1060 }} />
      <FeedBackDialog {...copyFeedbackHooks} modalStyle={{ zIndex: 1060 }} />
      {/* <Dialog
                show={showTip}
                timeCallback={() => { setShowTip(false) }}
                time={2000}
                type='tip'
                modalStyle={{zIndex: 1060}}
                iconType='success'
            >{message}</Dialog> */}
    </Fragment>
  );
};

export default MyDialog;
